/**
 * The Data 360 web-connector `partyIdentification` profile event that links an
 * anonymous browser (device / session) to a known CRM Contact.
 *
 * IDName / IDType MUST match the identity-resolution (S2) setup that consumes the
 * party-identification DMO — its `--party-name` / `--party-type` defaults. Change
 * them here, in one place, if that unit settles on different values.
 *
 * Field names follow the recommended web-connector schema
 * (cdn.c360a.salesforce.com/cdp/schemas/250/web-connector-schema.json).
 */
export const PARTY_IDENTIFICATION_ID_NAME = "CRM_Id";
export const PARTY_IDENTIFICATION_ID_TYPE = "CRM_Contact_Id";

export interface PartyIdentificationEvent {
    user: {
        attributes: {
            eventType: "partyIdentification";
            IDName: string;
            IDType: string;
            /** 18-character Salesforce Contact Id — never an email address. */
            userId: string;
        };
    };
}

export function buildPartyIdentificationEvent(contactId: string): PartyIdentificationEvent {
    return {
        user: {
            attributes: {
                eventType: "partyIdentification",
                IDName: PARTY_IDENTIFICATION_ID_NAME,
                IDType: PARTY_IDENTIFICATION_ID_TYPE,
                userId: contactId,
            },
        },
    };
}
